// extracted by mini-css-extract-plugin
export default {"group":"group_group","groupCaption":"group_groupCaption","optionContainer":"group_optionContainer","isBazaarVoiceTerms":"group_isBazaarVoiceTerms","tableRow":"group_tableRow"};